import { IAppState } from "../index";

export const selectState = (state: IAppState) => {
  return state.collection;
};

export const selectCollections = (state: IAppState) => {
  return selectState(state).collections;
};

export const selectCollectionAggregatedData = (state: IAppState) => {
  return selectState(state).aggregatedData;
};

export const selectSelectedCollection = (state: IAppState) => {
  return selectState(state).selectedCollection;
};

export const selectPublishedAggregation = (state: IAppState) => {
  return selectState(state).publishedAggregation;
};

export const selectClusterAggreagtion = (state: IAppState) => {
  return selectState(state).clusterAggregation;
};

export const selectClusterFacets = (state: IAppState) => {
  return selectState(state).clusterFacets;
};

export const selectAdvanceClusterAggregation = (state: IAppState) => {
  return selectState(state).advanceClusterAggregation;
};

export const selectAdvanceClusterFacets = (state: IAppState) => {
  return selectState(state).advanceClusterFacets;
};

export const selectPaginatedAggregatedData = (state: IAppState) => {
  return selectState(state).paginatedAggregatedData;
};

export const selectSingleRecommendation = (state: IAppState) => {
  return selectState(state).singleRecommendation;
};

export const selectRecommendationConfig = (state: IAppState) => {
  return selectState(state).recommendationConfig;
};

export const selectRecommendationSearchResults = (state: IAppState) => {
  return selectState(state).recommendationSearchResults;
};
